import { render, staticRenderFns } from "./Tag2.vue?vue&type=template&id=e1bedada&scoped=true"
import script from "./Tag2.vue?vue&type=script&lang=js"
export * from "./Tag2.vue?vue&type=script&lang=js"
import style0 from "./Tag2.vue?vue&type=style&index=0&id=e1bedada&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bedada",
  null
  
)

export default component.exports